<div class="card-container">
  <div class="card-header-wrapper">
    <div class="w-100">
      <!-- Back button -->
      <div class="row">
        <div class="col-md-12">
          <button
            kendoButton
            (click)="goBack()"
            icon="arrow-chevron-left"
            look="clear"
          >
            Go Back
          </button>
        </div>
      </div>
      <!-- Header information -->
      <div class="row w-100">
        <ng-container *ngIf="appointment != null">
          <!-- Left side - appointment info -->
          <div class="col-md-6">
            <h4 class="wtd-blue pb-0">
              <strong>Appointment</strong>
            </h4>
            <div style="display: flex; align-items: baseline; gap: 0rem">
              <p>
                <strong>Date and time: </strong>{{ getDateFormatted() }}
                {{ currenntTimezone }}
                {{
                  expertAppointmentTime != null
                    ? '( Expert: ' + expertAppointmentTime + ''
                    : ''
                }}{{
                  doctorAppointmentTime != null
                    ? ' | Doctor: ' + doctorAppointmentTime + ' )'
                    : ''
                }}
              </p>
            </div>
            <div *ngIf="!appointment.confirmed">
              <p style="font-weight: bold">
                Waiting on: {{ appointment.needs_confirmation_by }}
              </p>
            </div>
            <div *ngIf="!appointment.confirmed">
              <p style="font-style: italic">
                Time since requested: {{ getCreatedAt() }}
              </p>
            </div>
            <div>
              <p style="font-style: italic">
                Last updated: {{ getUpdatedAt() }}
              </p>
            </div>

            <div
              *ngIf="
                appointment.consultation != null &&
                appointment.consultation[0] != ''
              "
              class="mt-2"
              style="display: flex; gap: 0.5rem"
            >
              <ng-container *ngIf="appointment.urgent">
                <span class="badge badge-warning"> Urgent </span>
              </ng-container>

              <ng-container *ngIf="appointment.consultation[0] === 'closed'">
                <span class="badge badge-dark"> Closed </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.consultation[0] === 'open' &&
                  !appointment.confirmed
                "
              >
                <span
                  class="mr-2 badge
                        {{
                    appointment.urgent ? 'badge-warning' : 'badge-secondary'
                  }}"
                >
                  Unconfirmed
                </span>
              </ng-container>

              <ng-container *ngIf="appointment.consultation[0] === 'review'">
                <span class="badge badge-tertiary"> Confirmed </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.consultation[0] === 'open' &&
                  !appointment.confirmed &&
                  appointment.info_requested
                "
              >
                <span class="badge badge-warning"> Info Requested </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.consultation[0] === 'open' &&
                  !appointment.confirmed &&
                  appointment.reschedule_requested
                "
              >
                <span class="badge badge-warning"> Reschedule </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.consultation[0] === 'open' &&
                  appointment.confirmed
                "
              >
                <span class="badge badge-success"> Confirmed </span>
              </ng-container>

              <ng-container *ngIf="appointment.expectation == null && pastTime">
                <span class="badge badge-secondary"> No Review </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.expectation != null &&
                  appointment.expectation == true
                "
              >
                <span class="badge badge-success"> Met Expectation </span>
              </ng-container>

              <ng-container
                *ngIf="
                  appointment.expectation != null &&
                  appointment.expectation == false
                "
              >
                <span class="badge badge-error">
                  Did Not Meet Expectation
                </span>
              </ng-container>
            </div>

            <ng-container *ngIf="!pastTime">
              <button
                class="mt-2 mb-2 mr-2"
                kendoButton
                (click)="cimaSelectionoOpen = true"
              >
                Message All
              </button>
              <button
                class="mt-2 mb-2 mr-2"
                kendoButton
                (click)="handleEditTime()"
              >
                Update Time
              </button>
              <button
                class="mt-2 mb-2 mr-2"
                kendoButton
                (click)="openStatusChange()"
              >
                {{
                  appointment.urgent
                    ? 'Change to Non-Urgent'
                    : 'Change to Urgent'
                }}
              </button>
              <button
                *ngIf="
                  appointment.confirmed &&
                  appointment.consultation[0] !== 'closed'
                "
                class="mt-2 mb-2 mr-2"
                kendoButton
                (click)="openAddToCalendar()"
              >
                Add to Calendar
              </button>
            </ng-container>

            <ng-container
              *ngIf="
                appointment.urgent &&
                appointment.confirmed == false &&
                appointment.urgent_confirmed == false &&
                appointment.consultation[0] === 'open'
              "
            >
              <button
                class="mt-2 mb-2 mr-2"
                kendoButton
                (click)="closeAppointmentDialog()"
              >
                Cancel Appointment
              </button>
            </ng-container>

            <button
              class="mr-2"
              *ngIf="
                appointment.zoom_join != null &&
                appointment.zoom_join != '' &&
                withinTime
              "
              kendoButton
              (click)="handleJoin()"
            >
              Join
            </button>
            <button
              *ngIf="
                appointment.zoom_start != null &&
                appointment.zoom_start != '' &&
                withinTime
              "
              kendoButton
              (click)="handleStart()"
            >
              Start
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <span></span>
  </div>

  <!-- Main content -->
  <div class="card-component">
    <div class="appointment-info" *ngIf="appointment != null">
      <div class="row">
        <!-- Left side -->
        <div class="col-md-4 flex-row">
          <!-- DOCTOR info -->
          <ng-container *ngIf="doctor != null">
            <div class="doctor-info border-card">
              <h4>Doctor Details</h4>
              <ng-container *ngIf="doctorCurrentTime != null">
                <p>
                  <strong>Current Time (Doctor): </strong>
                  {{ doctorCurrentTime }}
                </p>
                <p>
                  <strong>Timezone (Doctor): </strong>
                  {{ this.orgLocation.timezone.label }}
                </p>
              </ng-container>
              <p>
                <strong>Requested by: </strong>
                {{ doctor.first_name | titlecase }}
                {{ doctor.last_name | titlecase }}
              </p>
              <p>
                <strong>Requested by: </strong>
                {{ doctor.first_name | titlecase }}
                {{ doctor.last_name | titlecase }}
              </p>
              <p>
                <strong>Requester email:</strong>
                {{
                  doctor.email != null || doctor.email != ''
                    ? ''
                    : 'Not available'
                }}
                <span
                  ><a
                    visibility="{{
                      doctor.email != null || expert.email != ''
                        ? 'visible'
                        : 'collapsed'
                    }}"
                    href="mailto:{{ doctor.email }}"
                    >{{ doctor.email }}</a
                  ></span
                >
              </p>
              <p>
                <strong>Requester phone:</strong>
                {{
                  doctor.phone != null && doctor.phone != ''
                    ? ''
                    : 'Not available'
                }}
                <span
                  visibility="{{
                    doctor.phone != null && doctor.phone != ''
                      ? 'visible'
                      : 'collapsed'
                  }}"
                  (click)="cimaDoctorSelectionoOpen = true"
                  style="cursor: pointer; color: #71a6ff"
                  >{{ doctor.phone }}</span
                >
                <!-- <span
                  visibility="{{
                    doctor.phone != null && doctor.phone != ''
                      ? 'visible'
                      : 'collapsed'
                  }}"
                  ><a href="tel:{{ doctor.phone }}">{{ doctor.phone }}</a></span> -->
              </p>
              <p *ngIf="pastTime">
                <strong>Joined time: </strong>
                <span
                  [class]="
                    appointment.hospital_join_time == null
                      ? 'wtd-red text-bold'
                      : ''
                  "
                  >{{ formatDate(appointment.hospital_join_time) }}</span
                >
              </p>

              <ng-container *ngIf="!pastTime">
                <div style="display: flex; justify-content: space-around">
                  <p style="text-align: center">
                    <button
                      class="mt-4 mb-2"
                      kendoButton
                      (click)="cimaDoctorSelectionoOpen = true"
                    >
                      Message Doctor
                    </button>
                  </p>
                  <p>
                    <!-- TODO - add back in -->
                    <button
                      [disabled]="true"
                      class="mt-4 mb-2"
                      kendoButton
                      (click)="handleDoctorSearch()"
                    >
                      Replace Doctor
                    </button>
                  </p>
                </div>
              </ng-container>

              <!-- Doctor Messages -->
              <ng-container *ngIf="doctorMessagesList.length > 0">
                <div style="display: flex" class="mt-4 mb-2">
                  <h3 class="mr-2">Messages</h3>
                </div>
                <div class="mb-2" *ngFor="let log of doctorMessagesList">
                  <p>
                    <span style="font-style: italic; font-weight: bold">{{
                      log.created_at | date : 'medium'
                    }}</span
                    >: {{ log.message }}<br />{{ log.username }}
                  </p>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <!-- ORG LOCATION info -->
          <ng-container *ngIf="orgLocation != null">
            <div class="org-location-info border-card">
              <h4>Location Details</h4>
              <p><strong>Location: </strong> {{ orgLocation.location_name }}</p>
              <p>
                <strong>Location Phone: </strong>
                <span
                  visibility="{{
                    orgLocation.phone != null && orgLocation.phone != ''
                      ? 'visible'
                      : 'collapsed'
                  }}"
                  style="cursor: pointer; color: #71a6ff"
                  >{{ orgLocation.phone }}</span
                >
              </p>
              <p>
                <strong>Location Email: </strong>
                <span
                  ><a href="mailto:{{ orgLocation.email }}">{{
                    orgLocation.email
                  }}</a></span
                >
              </p>
              <p>
                <strong>Parent organization: </strong>
                {{ orgLocation.org_name }}
              </p>
              <ng-container *ngIf="!pastTime">
                <p style="text-align: center">
                  <button
                    class="mt-2 mb-2"
                    kendoButton
                    (click)="cimaLocationSelectionoOpen = true"
                  >
                    Message Location
                  </button>
                </p>
              </ng-container>

              <!-- Location Messages -->
              <ng-container *ngIf="locationMessagesList.length > 0">
                <div style="display: flex" class="mt-4 mb-2">
                  <h3 class="mr-2">Messages</h3>
                </div>
                <div class="mb-2" *ngFor="let log of locationMessagesList">
                  <p>
                    <span style="font-style: italic; font-weight: bold">{{
                      log.created_at | date : 'medium'
                    }}</span
                    >: {{ log.message }}<br />{{ log.username }}
                  </p>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- PATIENT info -->
          <div class="border-card" *ngIf="patient != null">
            <h4>Patient Details</h4>
            <div class="patient-additional-info pt-2">
              <p>
                <strong>Patient name:</strong>
                {{ patient.first_name | titlecase }}
                {{ patient.last_name | titlecase }}
              </p>
              <p><strong>Additional patient informaiton:</strong></p>
              <p>
                Sex {{ patient.sex }} | Age
                {{ getAge(patient.date_of_birth) }} | Height
                {{ getHeight(patient) }} | Weight {{ patient.weight }}
                {{ patient.units == 'metric' ? 'kgs' : 'lbs' }} | BMI
                {{ getBMI(patient) }}
              </p>
              <p>Allergies:</p>
              <p>
                {{
                  patient.allergies != null && patient.allergies != ''
                    ? patient.allergies
                    : 'None'
                }}
              </p>
              <p>Medications:</p>
              <p>
                {{
                  patient.medications != null && patient.medications != ''
                    ? patient.medications
                    : 'None'
                }}
              </p>
              <p>Past Medical History:</p>
              <p>
                {{
                  patient.medical_history != null &&
                  patient.medical_history != ''
                    ? patient.medical_history
                    : 'None'
                }}
              </p>
              <p>Past Surgical History:</p>
              <p>
                {{
                  patient.surgical_history != null &&
                  patient.surgical_history != ''
                    ? patient.surgical_history
                    : 'None'
                }}
              </p>
            </div>
          </div>
        </div>
        <!-- Middle content -->
        <div class="col-md-4 flex-row">
          <!-- EXPERT info -->
          <ng-container *ngIf="expert != null">
            <div class="border-card">
              <h4>Expert Details</h4>
              <ng-container *ngIf="expertCurrentTime != null">
                <p>
                  <strong>Current Time (Expert): </strong>
                  {{ expertCurrentTime }}
                </p>
                <p>
                  <strong>Timezone (Expert): </strong>
                  {{ this.expert.timezone.label }}
                </p>
              </ng-container>
              <p>
                <strong>Expert name:</strong>
                {{ expert.first_name | titlecase }}
                {{ expert.last_name | titlecase }}
              </p>
              <p><strong>Expert Time Zone:</strong> PST</p>
              <p>
                <strong>Expert email:</strong>
                {{
                  expert.email != null || expert.email != ''
                    ? ''
                    : 'Not available'
                }}
                <span
                  ><a
                    visibility="{{
                      expert.email != null || expert.email != ''
                        ? 'visible'
                        : 'collapsed'
                    }}"
                    href="mailto:{{ expert.email }}"
                    >{{ expert.email }}</a
                  ></span
                >
              </p>
              <p>
                <strong>Expert phone:</strong>
                {{
                  expert.phone != null && expert.phone != ''
                    ? ''
                    : 'Not available'
                }}
                <span
                  visibility="{{
                    expert.phone != null && expert.phone != ''
                      ? 'visible'
                      : 'collapsed'
                  }}"
                  (click)="cimaExpertSelectionoOpen = true"
                  style="cursor: pointer; color: #71a6ff"
                  >{{ expert.phone }}</span
                >
                <!-- <span
                  ><a
                    visibility="{{
                      expert.phone != null && expert.phone != ''
                        ? 'visible'
                        : 'collapsed'
                    }}"
                    href="tel:{{ expert.phone }}"
                    >{{ expert.phone }}</a
                  ></span
                > -->
              </p>
              <p *ngIf="pastTime">
                <strong>Joined time: </strong>
                <span
                  [class]="
                    appointment.expert_join_time == null
                      ? 'wtd-red text-bold'
                      : ''
                  "
                  >{{ formatDate(appointment.expert_join_time) }}</span
                >
              </p>
              <ng-container *ngIf="!pastTime">
                <div class="expert-buttons">
                  <p style="text-align: center">
                    <button
                      class="mt-4 mb-2"
                      kendoButton
                      (click)="cimaExpertSelectionoOpen = true"
                    >
                      Message Expert
                    </button>
                  </p>
                  <p>
                    <button
                      [disabled]="searchExperts"
                      class="mt-4 mb-2"
                      kendoButton
                      (click)="handleExpertSearch()"
                    >
                      Replace Expert
                    </button>
                  </p>
                </div>
              </ng-container>

              <!-- Expert Messages -->
              <ng-container *ngIf="expertMessagesList.length > 0">
                <div style="display: flex" class="mt-4 mb-2">
                  <h3 class="mr-2">Messages</h3>
                </div>
                <div class="mb-2" *ngFor="let log of expertMessagesList">
                  <p>
                    <span style="font-style: italic; font-weight: bold">{{
                      log.created_at | date : 'medium'
                    }}</span
                    >: {{ log.message }}<br />{{ log.username }}
                  </p>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- Consult details -->
          <div class="consult-details-info border-card">
            <h4>Consult Details</h4>
            <!-- DETAILS info -->
            <ng-container
              *ngIf="
                appointment.zoom_video_url != null &&
                appointment.zoom_meeting_password != null
              "
            >
              <p>
                <strong>Consult Recording: </strong>
                <span
                  ><a
                    target="_blank"
                    style="text-decoration: underline; font-weight: bold"
                    href="{{ appointment?.zoom_video_url }}"
                    >Watch - Click Here</a
                  ></span
                >
              </p>
              <p>
                <strong>Recording Password (Click to copy): </strong>
                <span
                  (click)="copyToClipboard(appointment?.zoom_meeting_password)"
                  style="cursor: pointer; color: #71a6ff"
                  >{{ appointment?.zoom_meeting_password }}</span
                >
              </p>
              <hr />
            </ng-container>

            <p>
              <strong>Specialtiy:</strong>
              {{ appointment.specialty.specialty_name }}
            </p>
            <p>
              <strong>Sub Specialty:</strong>
              {{ appointment.sub_specialty.sub_specialty_name }}
            </p>
            <p
              *ngIf="
                appointment.chief_complaint != null &&
                appointment.chief_complaint != ''
              "
            >
              <strong>Chief Complaint:</strong>
              {{ appointment.chief_complaint }}
            </p>

            <p
              *ngIf="
                appointment.history_of_illness != null &&
                appointment.history_of_illness != ''
              "
            >
              <strong>History of present illness:</strong>
              {{ appointment.history_of_illness }}
            </p>

            <p
              *ngIf="
                appointment.expert_request != null &&
                appointment.expert_request.length > 0 &&
                appointment.expert_request[0] != ''
              "
            >
              <strong>Expert Additional Info Requests:</strong>
              {{
                appointment.expert_request != null ||
                appointment.expert_request.length > 0
                  ? appointment.expert_request
                  : 'Not available'
              }}
            </p>
            <ng-container
              *ngIf="
                appointment.expert_notes != null &&
                appointment.expert_notes.length > 0
              "
            >
              <p><strong>Expert notes:</strong></p>
              <div *ngFor="let note of appointment.expert_notes">
                <p>{{ note }}</p>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                appointment.general_consult_notes != null &&
                appointment.general_consult_notes.length > 0
              "
            >
              <p><strong>Doctor notes:</strong></p>
              <div *ngFor="let note of appointment.general_consult_notes">
                <p>{{ note }}</p>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                appointment.messages != null && appointment.messages.length > 0
              "
            >
              <p><strong>Messages:</strong></p>
              <div *ngFor="let note of appointment.messages">
                <p>{{ note }}</p>
              </div>
            </ng-container>

            <p
              *ngIf="
                appointment.consult_notes != null &&
                appointment.consult_notes != ''
              "
            >
              <strong>Consultation notes:</strong>
              {{
                appointment.consult_notes != null ||
                appointment.consult_notes.length > 0
                  ? appointment.consult_notes
                  : 'Not available'
              }}
            </p>
            <p *ngIf="appointment.expectation != null">
              <strong>Consultation expectation</strong>
              {{ appointment.expectation ? 'Good' : 'Needs Improvement' }}
            </p>
            <h4 class="mt-4">Relevant Labs</h4>
            <div *ngIf="relevantLabList != null">
              <div>
                <div
                  *ngFor="
                    let relevantLab of this.relevantLabList;
                    let labIndex = index
                  "
                  class="mt-2"
                  (click)="relevantLabTap(relevantLab)"
                >
                  <div
                    class="relevant-lab-row round-corner wtd-gray-bg pointer-cursor"
                  >
                    <p><strong>Name:</strong> {{ relevantLab.test_name }}</p>
                    <p>{{ relevantLab.document_name }}</p>
                    <p>
                      <strong>Description:</strong>
                      {{ relevantLab.test_description }}
                    </p>
                    <p><strong>Date:</strong> {{ relevantLab.test_date }}</p>
                  </div>
                </div>
              </div>
              <div *ngIf="relevantLabList.length == 0">
                <p>None Available</p>
              </div>
            </div>
          </div>
          <!-- Admin consult review notes -->
          <ng-container
            *ngIf="
              appointment.consultation[0] === 'closed' &&
              appointment.expectation == false
            "
          >
            <div class="consult-details-info border-card">
              <h4>Admin Review</h4>
              <!-- Resolution form -->
              <ng-container *ngIf="appointment.expectation_resolved">
                <p>Resolution: {{ appointment.admin_resolution_notes }}</p>
              </ng-container>
              <ng-container *ngIf="!appointment.expectation_resolved">
                <form
                  class="k-form"
                  style="max-width: 700px"
                  [formGroup]="adminResolutionNoteFormGroup"
                >
                  <fieldset class="k-form-fieldset">
                    <kendo-formfield orientation="vertical">
                      <kendo-label
                        [for]="admin_resolution_notes"
                        text="Describe what was done to resolve the issue."
                      >
                      </kendo-label>
                      <kendo-textarea
                        #admin_resolution_notes
                        [rows]="5"
                        formControlName="admin_resolution_notes"
                      >
                      </kendo-textarea>
                      <kendo-formerror>
                        Error: Please add a short summary.
                      </kendo-formerror>
                    </kendo-formfield>

                    <hr />
                    <div
                      class="k-form-buttons"
                      style="display: flex; justify-content: center"
                    >
                      <button
                        kendoButton
                        [primary]="true"
                        (click)="handleSubmitAdminResolution()"
                      >
                        Submit
                      </button>
                    </div>
                  </fieldset>
                </form>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <!-- Right content -->
        <div
          class="col-md-4"
          *ngIf="!searchExperts && !updateTime && !expertListLoaded"
        >
          <!-- Send request / confirm regular appointment -->
          <!-- <ng-container
            *ngIf="
              !appointment.confirmed &&
              !appointment.reschedule_requested &&
              !appointment.info_requested &&
              !appointment.urgent_confirmed &&
              !appointment.canceled &&
              !pastTime
            "
          >
            <div class="consult-details-info border-card mb-4">
              <p>
                If there are additional labs or information you would like to
                request, please note them below.
              </p>
              <form
                class="k-form"
                style="max-width: 700px"
                [formGroup]="submitRequestForm"
              >
                <fieldset class="k-form-fieldset">
                  <kendo-formfield orientation="vertical">
                    <kendo-textarea
                      #requestText
                      required="false"
                      [rows]="3"
                      formControlName="requestText"
                    >
                    </kendo-textarea>
                    <kendo-formerror>
                      Error: Please add a note.
                    </kendo-formerror>
                  </kendo-formfield>

                  <ng-container *ngIf="appointment.expert_request.length > 0">
                    <p><strong>Did you receive requested info?</strong></p>
                    <kendo-buttongroup
                      selection="single"
                      class="d-flex justify-content-center"
                    >
                      <button
                        kendoButton
                        [toggleable]="true"
                        (selectedChange)="selectedChange($event, true)"
                      >
                        Yes
                      </button>
                      <button
                        kendoButton
                        [toggleable]="true"
                        (selectedChange)="selectedChange($event, false)"
                      >
                        No
                      </button>
                    </kendo-buttongroup>
                  </ng-container>

                  <p>Requested Appointment Time</p>
                  <p>{{ getDateFormatted() }}</p>
                  <ng-container *ngIf="confirmAppointmentError">
                    <p style="color: red">Please select an option.</p>
                  </ng-container>
                  <hr />

                  <div
                    class="k-form-buttons"
                    style="display: flex; justify-content: center"
                  >
                    <button
                      kendoButton
                      [primary]="true"
                      (click)="handleRequest()"
                    >
                      Send Request
                    </button>
                    <ng-container *ngIf="!appointment.urgent">
                      <button
                        kendoButton
                        [primary]="true"
                        (click)="confirmAppointment()"
                      >
                        Confirm
                      </button>
                    </ng-container>
                  </div>
                </fieldset>
              </form>
            </div>
          </ng-container> -->

          <!-- Select an urgent time -->
          <!-- <ng-container
            *ngIf="
              !appointment.confirmed &&
              !appointment.reschedule_requested &&
              !appointment.info_requested &&
              !appointment.urgent_confirmed &&
              !appointment.canceled &&
              !pastTime &&
              appointment.urgent &&
              daysLoaded
            "
          >
            <div class="consult-details-info border-card mb-4">
              <p><strong>Select a time to confirm this appointment.</strong></p>
              <p>Times shown in {{ timezone }}</p>
              <div
                style="
                  margin: 30px;
                  display: flex;
                  justify-content: space-between;
                "
                *ngFor="let date of days; let i = index"
              >
                <p>{{ date }}</p>
                <Button class="k-button k-primary" (click)="selectDate(date, i)"
                  >Select</Button
                >
              </div>
            </div>
          </ng-container> -->

          <!-- Admin notes -->
          <div class="consult-details-info border-card">
            <h4>Admin Notes</h4>
            <!-- Resolution form -->
            <form
              class="k-form"
              style="max-width: 700px"
              [formGroup]="adminNoteFormGroup"
            >
              <fieldset class="k-form-fieldset">
                <kendo-formfield orientation="vertical">
                  <kendo-label [for]="admin_note" text="Add notes:">
                  </kendo-label>
                  <kendo-textarea
                    #admin_note
                    [rows]="3"
                    formControlName="admin_note"
                  >
                  </kendo-textarea>
                  <kendo-formerror> Error: Please add a note. </kendo-formerror>
                </kendo-formfield>

                <hr />
                <div
                  class="k-form-buttons"
                  style="display: flex; justify-content: center"
                >
                  <button
                    kendoButton
                    [primary]="true"
                    (click)="handleSubmitAdminNote()"
                  >
                    Submit
                  </button>
                </div>
              </fieldset>
            </form>
            <ng-container *ngIf="adminNotes.length > 0">
              <div class="mt-2 mb-2" *ngFor="let note of adminNotes">
                <p>
                  <span style="font-style: italic; font-weight: bold">
                    {{ note.created_at | date : 'medium' }}</span
                  >: {{ note.message }}<br />{{ note.username }}
                </p>
              </div>
            </ng-container>
          </div>

          <!-- Events -->
          <div style="display: flex" class="mt-4 mb-2">
            <h3 class="mr-2">Events</h3>
            <button class="mr-2" kendoButton (click)="sortEvents()">
              Sort: {{ sort == 'asc' ? 'Asc ↑' : 'Desc ↓' }}
            </button>
          </div>

          <ng-container *ngIf="eventLogs != null">
            <div class="mb-2" *ngFor="let log of eventLogs">
              <p>
                <span style="font-style: italic; font-weight: bold">{{
                  log.created_at | date : 'medium'
                }}</span
                >: {{ log.message }}<br />{{ log.username }}
              </p>
            </div>
          </ng-container>
        </div>

        <div class="col-md-4" *ngIf="searchExperts">
          <h3 class="mb-2">Search Experts</h3>
          <button
            class="mb-4"
            kendoButton
            *ngIf="appointment.session_invites_sent"
            (click)="expertFoundOpened = true"
          >
            Send Coverage Found Notice
          </button>
          <form
            class="k-form k-form-horizontal"
            style="max-width: 700px"
            [formGroup]="specialtyFormGroup"
          >
            <fieldset class="k-form-fieldset">
              <kendo-formfield orientation="horizontal">
                <kendo-label class="k-label" [for]="specialty" text="Specialty">
                </kendo-label>
                <kendo-combobox
                  formControlName="specialty"
                  [clearButton]="true"
                  #specialty
                  required
                  [data]="specialtyArray"
                  [textField]="'specialty_name'"
                  [valueField]="'id'"
                  [placeholder]="'Select Specialty'"
                  (valueChange)="selectedIndexChanged($event)"
                >
                </kendo-combobox>
                <kendo-formerror>
                  Error: Specialty is required
                </kendo-formerror>
              </kendo-formfield>
              <kendo-formfield orientation="horizontal">
                <kendo-label
                  class="k-label"
                  [for]="subSpecialty"
                  text="Sub Specialty"
                >
                </kendo-label>
                <kendo-combobox
                  [disabled]="isDisabledSubSpecialties"
                  formControlName="subSpecialty"
                  [clearButton]="true"
                  #subSpecialty
                  required
                  [data]="dataResultsSubSpecialties"
                  [textField]="'sub_specialty_name'"
                  [valueField]="'id'"
                  [placeholder]="'Select Sub Specialty'"
                  (valueChange)="selectedSubIndexChanged($event)"
                >
                </kendo-combobox>
                <kendo-formerror>
                  Error: Sub Specialty is required
                </kendo-formerror>
              </kendo-formfield>

              <hr />
              <div
                class="k-form-buttons"
                style="display: flex; justify-content: center"
              >
                <button kendoButton (click)="cancelChanges()">Cancel</button>
                <button kendoButton [primary]="true" (click)="hanndleSearch()">
                  Search
                </button>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="col-md-4" *ngIf="updateTime">
          <h3 class="mb-4">Update Time</h3>
          <div
            style="margin: 30px; display: flex; justify-content: space-between"
            *ngFor="let date of days; let i = index"
          >
            <p>{{ date }}</p>
            <Button class="k-button k-primary" (click)="selectDate(date, i)"
              >Select</Button
            >
          </div>
          <!-- <button
            style="display: block"
            class="mt-4"
            kendoButton
            (click)="handleUpdateTime(value)"
          >
            Update Time
          </button> -->
        </div>
        <div class="col-md-4" *ngIf="expertListLoaded && !searchExperts">
          <button
            class="mb-2"
            kendoButton
            look="flat"
            icon="arrow-left"
            (click)="handleGoBackToSearchExpert()"
          >
            Go Back
          </button>
          <h3>Experts</h3>
          <button
            class="mb-4"
            kendoButton
            *ngIf="appointment.session_invites_sent"
            (click)="expertFoundOpened = true"
          >
            Send Coverage Found Notice
          </button>
          <div class="expert-container mb-4" *ngFor="let expert of experts">
            <div class="d-flex flex-column">
              <p>
                {{ expert.first_name | titlecase }}
                {{ expert.last_name | titlecase }}
              </p>
              <span
                ><a
                  visibility="{{
                    expert.phone != null && expert.phone != ''
                      ? 'visible'
                      : 'collapsed'
                  }}"
                  href="tel:{{ expert.phone }}"
                  >{{ expert.phone }}</a
                ></span
              >
            </div>

            <button class="" kendoButton (click)="handleInviteExpert(expert)">
              Invite
            </button>
            <button class="" kendoButton (click)="handleReplaceExpert(expert)">
              Replace
            </button>
          </div>
          <button class="mb-2" kendoButton (click)="handleInviteAll()">
            Send Coverage Request
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialogs -->
  <kendo-dialog
    title="Please confirm"
    *ngIf="expertFoundOpened"
    (close)="closeCoverageNotice('cancel')"
    [minWidth]="250"
    [width]="450"
  >
    <p style="margin: 30px; text-align: center">
      Are you sure you want to send coverage notice?
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCoverageNotice('no')">No</button>
      <button kendoButton (click)="closeCoverageNotice('yes')" primary="true">
        Yes
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog
    title="Please confirm"
    *ngIf="replaceExpertOpen"
    (close)="closeReplaceExpert('cancel')"
    [minWidth]="250"
    [width]="450"
  >
    <p style="margin: 30px; text-align: center">
      Are you sure you want to replace expert?
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeReplaceExpert('no')">No</button>
      <button kendoButton (click)="closeReplaceExpert('yes')" primary="true">
        Yes
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog
    title=""
    *ngIf="formErrorOpen"
    (close)="formErrorOpen = false"
    [minWidth]="250"
    [width]="450"
  >
    <p style="margin: 30px; text-align: center">
      Please select at least a specialty
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="formErrorOpen = false" primary="true">
        Ok
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog
    title="Please confirm"
    *ngIf="closeAppointmentOpen"
    (close)="closeAppointment('cancel')"
    [minWidth]="250"
    [width]="450"
  >
    <p style="margin: 30px; text-align: center">
      Are you sure you want to close the appointment?
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeAppointment('no')">No</button>
      <button kendoButton (click)="closeAppointment('yes')" primary="true">
        Yes
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- EXPERT - Reminder message dialog -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please confirm message"
    *ngIf="expertReminderOpen"
    (close)="closeExpertReminder('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="expertReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #expertReminder
        [data]="expertMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedExpertMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="expertMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeExpertReminder('no')">Cancel</button>
      <button kendoButton (click)="closeExpertReminder('yes')" primary="true">
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- DOCTOR - Reminder message dialog -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please confirm message"
    *ngIf="doctorReminderOpen"
    (close)="closeDoctorReminder('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="doctorReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #doctorReminder
        [data]="doctorMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedDoctorMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="doctorMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeDoctorReminder('no')">Cancel</button>
      <button kendoButton (click)="closeDoctorReminder('yes')" primary="true">
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- LOCATION - Reminder message dialog -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please confirm message"
    *ngIf="locationReminderOpen"
    (close)="closeLocationReminder('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="locationReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #locationReminder
        [data]="locationMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedLocationMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="locationMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeLocationReminder('no')">Cancel</button>
      <button kendoButton (click)="closeLocationReminder('yes')" primary="true">
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Create a kendo dialog for messaging all similar to the dialogs above -->
  <kendo-dialog
    title="Please confirm message"
    *ngIf="allReminderOpen"
    (close)="closeAllReminder('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="allReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #allReminder
        [data]="allMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedAllMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="allMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeAllReminder('no')">Cancel</button>
      <button kendoButton (click)="closeAllReminder('yes')" primary="true">
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- URGENT STATUS - Confirm note of APPT status change -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please add reason for status change"
    *ngIf="statusChangeOpen"
    (close)="closeStatusChange('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="statusChangeText"
      ></kendo-textarea>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeStatusChange('no')">Cancel</button>
      <button
        kendoButton
        (click)="closeStatusChange('yes')"
        primary="true"
        [disabled]="isUpdateButtonDisabled()"
      >
        Update
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- CALENDAR - Add to calendar buttons -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Add to Calendar"
    *ngIf="addToCalendarOpen"
    (close)="closeAddToCalendar('cancel')"
    [minWidth]="250"
    [width]="600"
    class="add-to-calendar-dialog"
  >
    <div style="display: flex">
      <button kendoButton (click)="addToGoogleCalendar()">
        Add to Google Calendar
      </button>
      <button kendoButton (click)="addToGoogleCalendar()">
        Add to Yahoo Calendar
      </button>
      <button kendoButton (click)="addToGoogleCalendar()">
        Add to AOL Calendar
      </button>
    </div>
    <kendo-dialog-actions>
      <button
        kendoButton
        class="k-button k-primary"
        (click)="closeAddToCalendar('no')"
      >
        Done
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- ALL - CIMA Messaging Selection -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please choose contact method - Message All"
    *ngIf="cimaSelectionoOpen"
    (close)="closeCIMAMessageSelection('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="allReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #allReminder
        [data]="allMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedAllMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="allMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <div style="display: flex; flex-direction: column; padding: 10px 0px">
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="In App / Push Message"></kendo-label>
        <input
          type="radio"
          name="inapp"
          value="In App / Push Message"
          [(ngModel)]="selectedAllOption"
          #inapp
          kendoRadioButton
        />
      </div>
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="Text Message / CIMA"></kendo-label>
        <input
          type="radio"
          name="cima"
          value="Text Message / CIMA"
          [(ngModel)]="selectedAllOption"
          #cima
          kendoRadioButton
        />
      </div>
    </div>
    <div>
      <p style="font-style: italic">
        If CIMA is selected, the messages will be available in the CIMA
        dashboard.
      </p>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCIMAMessageSelection('no')">
        Cancel
      </button>
      <button
        kendoButton
        (click)="closeCIMAMessageSelection('yes')"
        primary="true"
      >
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- DOCTOR - CIMA Messaging Selection -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please choose contact method - Message Doctor"
    *ngIf="cimaDoctorSelectionoOpen"
    (close)="closeCIMADoctorMessageSelection('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="doctorReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #doctorReminder
        [data]="doctorMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedDoctorMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="doctorMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <div style="display: flex; flex-direction: column; padding: 10px 0px">
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="In App / Push Message"></kendo-label>
        <input
          type="radio"
          name="inapp"
          value="In App / Push Message"
          [(ngModel)]="selectedDoctorOption"
          #inapp
          kendoRadioButton
        />
      </div>
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="Text Message / CIMA"></kendo-label>
        <input
          type="radio"
          name="cima"
          value="Text Message / CIMA"
          [(ngModel)]="selectedDoctorOption"
          #cima
          kendoRadioButton
        />
      </div>
    </div>
    <div>
      <p style="font-style: italic">
        If CIMA is selected, the messages will be available in the CIMA
        dashboard.
      </p>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCIMADoctorMessageSelection('no')">
        Cancel
      </button>
      <button
        kendoButton
        (click)="closeCIMADoctorMessageSelection('yes')"
        primary="true"
      >
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- EXPERT - CIMA Messaging Selection -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please choose contact method - Message Expert"
    *ngIf="cimaExpertSelectionoOpen"
    (close)="closeCIMAExpertMessageSelection('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="expertReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #expertReminder
        [data]="expertMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedExpertMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="expertMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <div style="display: flex; flex-direction: column; padding: 10px 0px">
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="In App / Push Message"></kendo-label>
        <input
          type="radio"
          name="inapp"
          value="In App / Push Message"
          [(ngModel)]="selectedExpertOption"
          #inapp
          kendoRadioButton
        />
      </div>
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="Text Message / CIMA"></kendo-label>
        <input
          type="radio"
          name="cima"
          value="Text Message / CIMA"
          [(ngModel)]="selectedExpertOption"
          #cima
          kendoRadioButton
        />
      </div>
    </div>
    <div>
      <p style="font-style: italic">
        If CIMA is selected, the messages will be available in the CIMA
        dashboard.
      </p>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCIMAExpertMessageSelection('no')">
        Cancel
      </button>
      <button
        kendoButton
        (click)="closeCIMAExpertMessageSelection('yes')"
        primary="true"
      >
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- ------------------------------- -->
  <!-- LOCATION - CIMA Messaging Selection -->
  <!-- -------------------------------- -->
  <kendo-dialog
    title="Please choose contact method - Message Location"
    *ngIf="cimaLocationSelectionoOpen"
    (close)="closeCIMALocationMessageSelection('cancel')"
    [minWidth]="250"
    [width]="600"
  >
    <div style="display: flex; padding-bottom: 1rem">
      <kendo-label
        style="margin-right: 10px"
        class="customizing-label"
        [for]="locationReminder"
        text="Message"
      ></kendo-label>
      <kendo-combobox
        style="flex-grow: 1"
        [clearButton]="true"
        #locationReminder
        [data]="locationMessages"
        [placeholder]="'Select Message'"
        (valueChange)="selectedLocationMessageChange($event)"
      >
      </kendo-combobox>
    </div>
    <div style="display: flex">
      <kendo-textarea
        style="flex-grow: 1"
        [(ngModel)]="locationMessage"
        placeholder="Message"
      ></kendo-textarea>
    </div>
    <div style="display: flex; flex-direction: column; padding: 10px 0px">
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="In App / Push Message"></kendo-label>
        <input
          type="radio"
          name="inapp"
          value="In App / Push Message"
          [(ngModel)]="selectedLocationOption"
          #inapp
          kendoRadioButton
        />
      </div>
      <div style="display: flex; align-items: center; gap: 1em">
        <kendo-label [for]="inapp" text="Text Message / CIMA"></kendo-label>
        <input
          type="radio"
          name="cima"
          value="Text Message / CIMA"
          [(ngModel)]="selectedLocationOption"
          #cima
          kendoRadioButton
        />
      </div>
    </div>
    <div>
      <p style="font-style: italic">
        If CIMA is selected, the messages will be available in the CIMA
        dashboard.
      </p>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCIMALocationMessageSelection('no')">
        Cancel
      </button>
      <button
        kendoButton
        (click)="closeCIMALocationMessageSelection('yes')"
        primary="true"
      >
        Send
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
